import * as Sentry from '@sentry/vue'

import { App } from 'vue'
import { Router } from 'vue-router'

import { useAppConfig } from '../composables/app-config'

export function initSentry(app: App, router: Router) {
	const { sentryDSN, appStage, appVersion } = useAppConfig()

	if (!sentryDSN || appStage === 'DEV') {
		return
	}

	const integrations = [
		Sentry.browserTracingIntegration({ router }),
		Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
		Sentry.extraErrorDataIntegration(),
		Sentry.captureConsoleIntegration(),
		Sentry.httpClientIntegration(),
		Sentry.contextLinesIntegration()
	]

	if (appStage !== 'PRODUCTION') {
		integrations.push(Sentry.browserProfilingIntegration())
	}

	Sentry.init({
		dsn: sentryDSN,
		app,
		integrations,
		environment: appStage,
		release: `${appStage}@${appVersion}`,
		sendDefaultPii: true,
		tracesSampleRate: appStage === 'PRODUCTION' ? 0.2 : 1.0,
		replaysSessionSampleRate: appStage === 'PRODUCTION' ? 0.05 : 1.0,
		replaysOnErrorSampleRate: 1.0
	})
}
